export enum HumanNamePrefix {
  mr = 'Mr.',
  mrs = 'Mrs.',
  miss = 'Miss',
  prof = 'Prof.',
  dr = 'Dr.',
  sr = 'Sr.',
}
